import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MemberArea from '../components/MemberArea';
import apiClient from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api';

const MemberAreaPage = () => {
  const navigate = useNavigate();
  const [checkingRole, setCheckingRole] = useState(true);

  useEffect(() => {
    const checkAuthAndRole = async () => {
      // Cek apakah ada session/token di localStorage
      const authToken = localStorage.getItem('auth_token') || localStorage.getItem('access_token');
      
      // Jika tidak ada token, redirect ke halaman login
      if (!authToken) {
        navigate('/login', { replace: true });
        return;
      }

      // Cek role user dari localStorage atau API
      try {
        // Coba ambil dari localStorage dulu
        const savedUserData = localStorage.getItem('user_data');
        let userRole = null;

        if (savedUserData) {
          try {
            const parsed = JSON.parse(savedUserData);
            userRole = parsed.role?.id;
          } catch (error) {
            console.error('Error parsing user_data:', error);
          }
        }

        // Jika role tidak ditemukan di localStorage, fetch dari API
        if (!userRole) {
          try {
            // Fetch user data dari API
            const savedUserData = localStorage.getItem('user_data');
            if (savedUserData) {
              const parsed = JSON.parse(savedUserData);
              if (parsed.id) {
                const response = await apiClient.get(API_ENDPOINTS.USER.GET_BY_ID(parsed.id));
                
                let userFromApi = null;
                if (response.data && response.data.user) {
                  userFromApi = response.data.user;
                } else if (response.data && response.data.data) {
                  userFromApi = response.data.data;
                } else if (response.data && !response.data.user) {
                  userFromApi = response.data;
                } else if (!response.data) {
                  userFromApi = response;
                }
                
                if (userFromApi) {
                  userRole = userFromApi.role?.id;
                }
              }
            } else {
              // Jika tidak ada di localStorage, fetch dari /api/users/me
              const meResponse = await apiClient.get(API_ENDPOINTS.USER.GET_ME);
              if (meResponse.data && meResponse.data.data) {
                const userMe = meResponse.data.data;
                userRole = userMe.role?.id;
              }
            }
          } catch (error) {
            console.error('Error fetching user role:', error);
          }
        }

        // Jika role adalah RL00003 (mitra), redirect ke mitra-area
        if (userRole === 'RL00003') {
          navigate('/mitra-area', { replace: true });
          return;
        }

        // Jika role bukan mitra, lanjutkan ke member-area
        setCheckingRole(false);
      } catch (error) {
        console.error('Error checking role:', error);
        // Jika error, tetap lanjutkan (fallback)
        setCheckingRole(false);
      }
    };

    checkAuthAndRole();
  }, [navigate]);

  // Cek lagi sebelum render untuk mencegah flash
  const authToken = localStorage.getItem('auth_token') || localStorage.getItem('access_token');
  
  // Jika tidak ada token atau sedang checking role, return loading state
  if (!authToken || checkingRole) {
    return (
      <section className="min-h-screen bg-white">
        <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
          <div className="flex items-center justify-center h-screen">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <MemberArea />
  );
};

export default MemberAreaPage;
